// src/features/stabilimenti/stabilimentiSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  stabilimenti: [],
  singleStabilimento: {},
  selectedStabilimentiId: null,
  tipologia: [],
  isLoading: false,
  error: null,
  enumsLoading: {
    tipologia: false
  },
  enumsError: {
    tipologia: null
  }
};

const stabilimentiSlice = createSlice({
  name: "stabilimenti",
  initialState,
  reducers: {
    // Stabilimenti data management
    setStabilimenti: (state, action) => {
      state.stabilimenti = action.payload;
    },
    addStabilimenti: (state, action) => {
      state.stabilimenti.push(action.payload);
    },
    setSelectedStabilimentiId: (state, action) => {
      state.selectedStabilimentiId = action.payload;
    },
    setSingleStabilimento: (state, action) => {
      state.singleStabilimento = action.payload;
    },
    updateStabilimenti: (state, action) => {
      const index = state.stabilimenti.findIndex(
        (stabilimento) => stabilimento.id === action.payload.id
      );
      if (index !== -1) {
        state.stabilimenti[index] = action.payload;
      }
    },
    removeStabilimenti: (state, action) => {
      state.stabilimenti = state.stabilimenti.filter(
        (stabilimento) => stabilimento.id !== action.payload
      );
    },

    // API request states
    apiRequestStart: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    apiRequestSuccess: (state) => {
      state.isLoading = false;
    },
    apiRequestFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },

    // Enums management
    setTipologia: (state, action) => {
      state.tipologia = action.payload;
    },
    
    // Enum loading states
    enumRequestStart: (state, action) => {
      state.enumsLoading[action.payload] = true;
      state.enumsError[action.payload] = null;
    },
    enumRequestSuccess: (state, action) => {
      state.enumsLoading[action.payload] = false;
    },
    enumRequestFailure: (state, action) => {
      const { enumType, error } = action.payload;
      state.enumsLoading[enumType] = false;
      state.enumsError[enumType] = error;
    }
  },
});

// Export actions
export const {
  // Stabilimenti actions
  setStabilimenti,
  addStabilimenti,
  setSingleStabilimento,
  updateStabilimenti,
  removeStabilimenti,
  apiRequestStart,
  apiRequestSuccess,
  apiRequestFailure,
  setSelectedStabilimentiId,
  // Enum actions
  setTipologia,
  enumRequestStart,
  enumRequestSuccess,
  enumRequestFailure,
} = stabilimentiSlice.actions;  

// Export selectors
export const selectStabilimenti = (state) => state.stabilimenti.stabilimenti;
export const selectSingleStabilimento = (state) => state.stabilimenti.singleStabilimento;
export const selectIsLoading = (state) => state.stabilimenti.isLoading;
export const selectError = (state) => state.stabilimenti.error;
export const selectSelectedStabilimentiId = (state) => state.stabilimenti?.selectedStabilimentiId;
// Enum selectors
export const selectTipologia = (state) => state.stabilimenti.tipologia;

export default stabilimentiSlice.reducer;